<template>
	<div
		v-show="!isIframed"
		id="pick"
		ref="scene"
		:style="scene_style"
		class="scene"
	>
		<div class="step1">
			<div class="step1-bg">
				<div class="sky"></div>
				<div class="sun-clouds">
					<div class="sun"></div>
					<div class="cloud-1"></div>
					<div class="cloud-2"></div>
				</div>
				<div
					class="light-mountains"
					data-src="scenery-min.png"
				>
				</div>
				<div class="mountains"></div>
			</div>
			<div class="railing"></div>
		</div>

		<div class="step2">
			<div
				:style="step2_style"
				class="step2-bg"
			>
			</div>
			<div class="road"></div>
		</div>
		<div class="truck"></div>
		<div
			:style="truck_style"
			class="light-truck"
		>
		</div>
		<div class="sign">
			<div class="sign-board">
				<div class="sign-text">
					{{ sign_text }}
				</div>
			</div>
		</div>
		<div class="household"></div>

		<!--
		<img
			src="./assets/sun.png"
			style="display: none">
		<img
			src="./assets/cloud-1.png"
			style="display: none">
		<img
			src="./assets/cloud-2.png"
			style="display: none"
		>
		-->
		<img
			id="scenery"
			:src="require('@/assets/scenery-min.png')"
			style="display: none"
		/>
		<img
			id="truck"
			:src="require('@/assets/truck-min.png')"
			style="display: none"
		/>
		<!--
		<img
			src="./assets/railing.png"
			style="display: none">
		<img
			src="./assets/truck1.png"
			style="display: none">
		<img
			src="./assets/to.png"
			style="display: none">
		<img
			src="./assets/to-office.png"
			style="display: none">
		<img
			src="./assets/to-apt.png"
			style="display: none">
		<img
			src="./assets/when.png"
			style="display: none">
		<img
			src="./assets/when-office.png"
			style="display: none">
		<img
			src="./assets/when-apt.png"
			style="display: none">
		<img
			src="./assets/thanks.png"
			style="display: none"
		>
		-->
		<img
			id="hidden_gif"
			ref="hidden_gif"
			style="display: none"
		>
	</div>
</template>

<script>
import { mapState } from 'vuex';

export default {
	data() {
		return {
			scene_style: '',
			step2_style: {},
			truck_open: '',
			truck_style: {},
			scene_height: 0,
			scene_width: 0,
			sign_text: '?',
		};
	},

	computed: {
		...mapState({
			isIframed: state => state.iframeFlag,
			quote: state => state.quote,
			progress: state => state.progress,
			completed_steps: state => state.progress.completed_steps,
		}),

		// getDeliveryBg() {
		// 	return this.progress.delivery_bg;
		// },

		getShippingBg() {
			return this.progress.shipping_bg;
		},
	},

	watch: {
		completed_steps: {
			immediate: true,
			handler(to) {
				const step = to;

				this.$log.debug(step);

				this.$nextTick(() => {
					this.updateBackground(step);
					this.updateSign(step);
				});
			},
		},
	},

	created() {
		this.truck_open = require('@/assets/truck1.png');
	},

	mounted() {
		window.onresize = () => {
			this.updateSceneSize();
		};

		this.$nextTick(() => {
			this.updateSceneSize();
			this.loadImages();
		});
	},

	methods: {
		updateSceneSize: function() {
			// const scene = document.getElementsByClassName('scene')[0];
			const scene = this.$refs.scene;

			if (scene) {
				if (window.outerHeight < window.outerWidth) {
					scene.style.width = scene.clientHeight * 2 + 'px';
				} else {
					scene.style.height = scene.clientWidth / 2 + 'px';
				}
			}
		},
		updateBackground: function(step) {
			// const scene = document.getElementsByClassName('scene')[0];
			const scene = this.$refs.scene;
			let bgImage = '';

			this.scene_style = {};

			if (step < 3) {
				this.truck_style = {};
			}

			switch (step) {
				case 1:
					scene.id = 'pick';
					break;
				case 2:
					scene.id = 'move';
					break;
				case 3:
					bgImage = this.getShippingBg;

					this.step2_style = {
						'background-image': `url(${bgImage})`,
					};

					scene.id = 'when';
					setTimeout(() => {
						this.truck_style = {
							'background-image': `url(${this.truck_open})`,
						};
					}, 800);
					break;
				case 4:
					bgImage = this.getShippingBg;

					this.step2_style = {
						'background-image': `url(${bgImage})`,
					};

					scene.id = 'to';
					setTimeout(() => {
						this.truck_style = {
							'background-image': `url(${this.truck_open})`,
						};
					}, 800);

					break;
				case 5:
				case 6:
				case 7:
					bgImage = this.progress.quote_bg;

					if (this.$refs.hidden_gif) {
						this.$refs.hidden_gif.setAttribute('src', `${bgImage}?x=${Date.now()}`);
					}

					scene.id = 'quote';
					break;
				case 8:
					scene.id = 'thanks';
					break;
			}
		},
		updateSign: function(step) {
			this.$log.debug(step, this.quote);

			switch (step) {
				case 1:
					this.sign_text = '?';
					break;
				case 2:
				case 3:
				case 4:
					try {
						this.sign_text = this.quote.origin.state;
					} catch (err) {
						this.sign_text = 'US';
					}

					break;
			}
		},

		checkLoadedContent: function(data) {
			for (let i = 0; i < data.length; i++) {
				const imgEle = document.getElementById(data[i].imgId);
				const actualEle = document.getElementsByClassName(
					data[i].actualClass
				)[0];
				const blurEle = document.getElementsByClassName(
					data[i].bluryClass
				)[0];
				const img = new Image();

				if (imgEle) {
					const url = imgEle.src;

					img.onload = function() {
						if (blurEle) {
							blurEle.style.display = 'none';
							actualEle.style.display = 'block';
						}
					};
					img.src = url;

					if (img.complete) {
						img.onload();
					}
				}
			}
		},
		loadImages: function() {
			const resources = [
				{
					imgId: 'scenery',
					actualClass: 'mountains',
					bluryClass: 'light-mountains',
				},
				{
					imgId: 'truck',
					actualClass: 'truck',
					bluryClass: 'light-truck',
				},
			];

			this.checkLoadedContent(resources);
		},
	},
};
</script>

<style scoped lang="scss">
.scene#hide {
	display: none;
}

.scene {
	position: absolute;
	bottom: 0;
	left: 0;
	right: 0;
	height: 50vh;
	width: 100%;
	max-width: 780px;
	display: -ms-grid;
	display: grid;
	/* width: 85%; */
	margin: 6px auto;
	z-index: 0;
	overflow: hidden;

	.step1 {
		height: 100%;
		width: 100%;
		position: absolute;
		top: 0;
		left: 0;

		.step1-bg {
			width: 100%;
			height: 100%;
			transition: all 0.5s linear;
		}
	}

	.step2 {
		height: 100%;
		width: 100%;
		position: absolute;
		top: 0;
		right: 0;
		margin-right: -100%;
		transition: all 0.5s linear;

		.step2-bg {
			background-position: 50% 100%;
			background-size: contain;
			background-repeat: no-repeat;
			position: absolute;
			bottom: 6%;
			height: 90%;
			width: 100%;
		}
	}

	.scene-fg,
	.mountains {
		/*background-color: #d0e8f4;*/
		background-image: url("~@/assets/scenery-min.png");
		background-position: 50% 100%;
		background-size: contain;
		background-repeat: no-repeat;
		position: absolute;
		bottom: 10%;
		height: 90%;
		width: 100%;
		display: none;
	}

	.scene-fg,
	.light-mountains {
		/*background-color: #d0e8f4;*/
		background-image: url("~@/assets/scenery-tn.png");
		background-position: 50% 100%;
		background-size: contain;
		background-repeat: no-repeat;
		position: absolute;
		bottom: 10%;
		height: 90%;
		width: 100%;
	}

	.sky {
		background-image: url("~@/assets/sky.png");
		background-position: 50% 100%;
		background-size: contain;
		background-repeat: no-repeat;
		position: absolute;
		z-index: -1;
		height: 90%;
		width: 100%;
	}

	.scene-bg,
	.sun-clouds {
		position: absolute;
		z-index: 0;
		height: 100%;
		width: 100%;

		.sun {
			background-image: url("~@/assets/sun.png");
			background-repeat: no-repeat;
			background-position: 50% 0;
			background-size: contain;
			width: 6vw;
			height: 11vh;
			transition: all 0.5s linear;
			position: absolute;
			left: 23%;
			/* position: absolute;
      top: 20%;
      left: 22%; */
		}

		.cloud-1 {
			background-image: url("~@/assets/cloud-1.png");
			background-repeat: no-repeat;
			background-position: 50% 0%;
			background-size: contain;
			width: 8vw;
			height: 4vh;
			transition: all 0.5s linear;
			position: absolute;
			top: 15%;
			/* position: absolute;
      top: 22%;
      left: 48%; */
		}

		.cloud-2 {
			background-image: url("~@/assets/cloud-2.png");
			background-repeat: no-repeat;
			background-position: 50% 0;
			background-size: contain;
			width: 11vw;
			height: 7vh;
			transition: all 0.5s linear;
			position: absolute;
			top: 23%;
			/* position: absolute;
      width: 24%;
      height: 100px; */
		}
	}

	.railing {
		background-image: url("~@/assets/railing.png");
		background-repeat: no-repeat;
		background-position: 50% 100%;
		background-size: contain;
		width: 100%;
		height: 6vh;
		position: absolute;
		bottom: 6%;
		transition: all 0.2s linear;
		transition-delay: 0.5s;
	}
	.light-truck {
		background-image: url("~@/assets/truck-tn.png");
		background-repeat: no-repeat;
		background-position: 0% 100%;
		background-size: contain;
		width: 34vw;
		height: 16vh;
		position: absolute;
		bottom: 1.5%;
		z-index: 5;
		transition: all 0.5s linear;
		display: block;
	}
	.truck {
		background-image: url("~@/assets/truck-min.png");
		background-repeat: no-repeat;
		background-position: 0% 100%;
		background-size: contain;
		width: 34vw;
		height: 16vh;
		position: absolute;
		bottom: 1.5%;
		z-index: 5;
		transition: all 0.5s linear;
		display: none;
	}
	.sign {
		background-image: url("~@/assets/sign.png");
		background-repeat: no-repeat;
		background-size: contain;
		background-position: 50% 100%;
		width: 8vw;
		height: 14vmin;
		position: absolute;
		right: 0;
		bottom: 6%;
		z-index: 5;

		.sign-board {
			position: relative;
			height: 100%;
		}

		.sign-text {
			position: absolute;
			top: 6%;
			left: 49%;
			font-size: 2.25vmin;
			font-weight: 700;
			margin-left: 2px;
			color: #df5435;
			transform: translate(-50%, 0);
		}
	}

	.household {
		background-image: url("~@/assets/household.png");
		background-position: 0 100%;
		background-size: contain;
		background-repeat: no-repeat;
		width: 22vw;
		height: 14vh;
		position: absolute;
		bottom: 0%;
		left: -100%;
		z-index: 6;
		transition: all 1s linear;
	}
}

.scene#pick {
	.step1-bg {
		transform: translateY(0);
	}

	.sun-clouds {
		.sun {
			top: 12%;
		}
		.cloud-1 {
			left: 47%;
		}
		.cloud-2 {
			left: 61%;
		}
	}

	.railing {
		height: 52px;
	}

	.truck {
		left: 0;
	}
}

.scene#move {
	.scene-bg,
	.sun-clouds {
		.sun {
			top: 36%;
		}
		.cloud-1 {
			left: 30%;
		}
		.cloud-2 {
			left: 42%;
		}
	}

	.railing {
		height: 52px;
	}

	.truck {
		left: 18%;
	}
}

.scene#when,
.scene#to {
	.step1 {
		.step1-bg {
			transform: translateY(100%);
		}
		.railing {
			height: 0;
		}
	}
	.step2 {
		margin-right: 0;
	}
	.truck {
		left: 36%;
	}
}

.scene#to {
	.household {
		left: 26%;
	}
}

.scene#quote {
	.step1,
	.step2,
	.truck,
	.household,
	.sign {
		display: none !important;
	}
}

.scene#thanks {
	background-image: url("~@/assets/thanks.png");
	background-position: 50%;
	background-repeat: no-repeat;
	background-size: contain;
	.step1,
	.step2,
	.truck,
	.household,
	.sign {
		display: none !important;
	}
}

@media (min-width: 1200px) {
	.scene {
		.railing {
			bottom: 6%;
		}
	}

	.scene#move {
		.sun-clouds {
			.sun {
				background-position-y: 54%;
			}
			.cloud-1 {
				background-position-y: 28%;
			}
			.cloud-2 {
				background-position-y: 40%;
			}
		}
	}
}

@media (max-width: 991px) {
	.scene {
		width: 100% !important;
		margin-left: 0;
		left: 0;
	}
}

@media (max-width: 600px) {
	.scene#quote {
		display: none;
		height: 0 !important;
	}
}
</style>
